export const USER_COLORS = [
  "#FF6B6B", // Red
  "#4ECDC4", // Teal
  "#45B7D1", // Blue
  "#96CEB4", // Green
  "#FECA57", // Yellow
  "#FF9FF3", // Pink
  "#54A0FF", // Light Blue
  "#5F27CD", // Purple
  "#00D2D3", // Cyan
  "#FF9F43", // Orange
  "#6C5CE7", // Indigo
  "#A29BFE", // Light Purple
  "#FD79A8", // Rose
  "#FDCB6E", // Light Orange
  "#6C5B7B", // Dark Purple
] as const;

export const getRandomUserColor = (): string => {
  return USER_COLORS[Math.floor(Math.random() * USER_COLORS.length)];
};
